import { KydSmartphoneEnrollmentContactDetail } from './kyd-smartphone-enrollment-contact-detail.model';

export interface KydSmartphoneEnrollmentOperator {
  customerIdentifier: string;
  extCustomerId: string;
  contactDetail: KydSmartphoneEnrollmentContactDetail;
}
